"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Determines wether the device is a mobile device based on its User agent name
 * @returns {boolean}
 * @example
 *
 * import { isMobileDevice } from '@demant/wdh';
 *
 * if (isMobileDevice()) {
 *  // Execute code only for mobile devices
 * }
 */
var isMobileDevice = function isMobileDevice() {
  return navigator.userAgent.match(/Android|webOS|iPhone|iPod|iPad|Blackberry|IEMobile|Opera Mini/i);
};

var _default = isMobileDevice;
exports["default"] = _default;